import { LegendDataResponse } from '@app/redux/riskMap/riskMapSlice'
import { fetchLegends } from '@app/services/legendService'
import { useQuery } from '@tanstack/react-query'

/**
 * Fetches map legends and caches them with React Query.
 * Pass a clientName so the cache key changes when the client changes.
 */

export function useFetchLegends(clientName: string) {
  return useQuery<Partial<LegendDataResponse>>({
    queryKey: ['legends', clientName],
    queryFn: () => fetchLegends(),
    enabled: Boolean(clientName),
    refetchOnMount: true,
  })
}
